import { GTM_CLS_COMMON } from "../features/Feature_Gtm/Gtm_BaseLogic";

const TriggerGTAEvent = (
  eventName: string,
  attributes: Record<string, any>
) => {
  if (
    ![
      "localhost",
      "sg-test.eastus.cloudapp.azure.com",
      "sitoneservice.adityabirlacapital.com",
      "oneservice.adityabirlacapital.com",
    ].includes(window.location.hostname)
  ) {
    return;
  }
  const eventData: Record<string, any> = { ...GTM_CLS_COMMON.eventObj };

  // Add dynamic attributes to eventData if they are not empty
  Object.entries(attributes).forEach(([key, value]: [string, any]) => {
    if (key !== "Client_ID" && value) {
      eventData[key] = value;
    }
  });

  if (sessionStorage.getItem("prevGTMPageName")) {
    const prevGTMPageName = sessionStorage.getItem("prevGTMPageName") || "";
    eventData.previous_screen_name = prevGTMPageName;
  } else {
    eventData.previous_screen_name = "";
  }

  if (attributes?.screen_name !== "") {
    sessionStorage.setItem("prevGTMPageName", attributes?.screen_name);
  }

  (window as any).dataLayer.push({
    event: eventName,
    ...eventData,
  });
};

export default TriggerGTAEvent;
